import { Component, OnInit } from '@angular/core';
import { RequestHelper } from '@helper/request.helper';

@Component({
  selector: 'app-bri-direct-debit',
  templateUrl: './bri-direct-debit.component.html',
  styleUrls: ['./bri-direct-debit.component.css']
})
export class BriDirectDebitComponent implements OnInit {

  active = 1;
  validCard: Array<{ lastFour: string, phoneNumber: string }>;
  registerCard: Array<{ scenario: string, lastFour: string, phoneNumber: string }>;
  validateRegisterCard: Array<{ scenario: string, lastFour: string, phoneNumber: string }>;
  payment: Array<{ scenario: string, lastFour: string, phoneNumber: string }>;
  validatePayment: Array<{ scenario: string, lastFour: string, phoneNumber: string }>;
  refundOnline: Array<{ scenario: string, invoiceNumber: string }>;
  moduleName = 'BRI';
  imageSource = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/bank/bri.png';

  constructor(private apiService: RequestHelper) { }

  ngOnInit(): void {
    this.validCard = [
      { lastFour: '8141', phoneNumber: '6287888697827' },
      { lastFour: '8224', phoneNumber: '6281394130621' },
      { lastFour: '8232', phoneNumber: '6285156862674' },
      { lastFour: '0116', phoneNumber: '6281287458328' }
    ];
    this.registerCard = [
      { scenario: 'Card number not found', lastFour: '0101', phoneNumber: '6287888697827' },
      { scenario: 'The expired date is incorrect', lastFour: '0102', phoneNumber: '6287888697827' },
      { scenario: 'Card was expiry', lastFour: '0103', phoneNumber: '6287888697827' },
      { scenario: 'Phone number not registered', lastFour: '0104', phoneNumber: '6287888697827' },
      { scenario: 'Card status not activated', lastFour: '0105', phoneNumber: '6287888697827' },
      { scenario: 'Binding failed', lastFour: '0106', phoneNumber: '6287888697827' },
      { scenario: 'Phone number is invalid', lastFour: '0107', phoneNumber: '6287888697827' },
      { scenario: 'National Id Number not matched', lastFour: '0108', phoneNumber: '6287888697827' },
      { scenario: 'Your card is blocked or disabled', lastFour: '0109', phoneNumber: '6287888697827' },
      { scenario: 'Your card is already registered', lastFour: '0110', phoneNumber: '6287888697827' },
      { scenario: 'Exceed limit binding', lastFour: '0112', phoneNumber: '6287888697827' },
      { scenario: 'Account is frozen', lastFour: '0405', phoneNumber: '6287888697827' },
      { scenario: 'Account is closed', lastFour: '0406', phoneNumber: '6287888697827' },
      { scenario: 'Passive account', lastFour: '0411', phoneNumber: '6287888697827' }
    ];
    this.validateRegisterCard = [
      { scenario: 'Expired Card Token', lastFour: '0603', phoneNumber: '628110603' },
      { scenario: 'Invalid Passcode', lastFour: '0918', phoneNumber: '628110918' },
      { scenario: 'Error Validate OTP Passcode', lastFour: '0919', phoneNumber: '628110919' },
      { scenario: 'Expired OTP', lastFour: '0920', phoneNumber: '628110920' },
      { scenario: 'Send OTP Failed', lastFour: '0921', phoneNumber: '628110921' },
      { scenario: 'Invalid OTP Token', lastFour: '0922', phoneNumber: '628110922' }
    ];
    this.payment = [
      { scenario: 'Over limit', lastFour: '0401', phoneNumber: '628110401' },
      { scenario: 'Payment currency not supported', lastFour: '0402', phoneNumber: '628110402' },
      { scenario: 'Charge payment failed', lastFour: '0403', phoneNumber: '628110403' },
      { scenario: 'Insufficient balance', lastFour: '0404', phoneNumber: '628110404' },
      { scenario: 'Account is frozen', lastFour: '0407', phoneNumber: '628110407' },
      { scenario: 'Account is closed', lastFour: '0408', phoneNumber: '628110408' },
      { scenario: 'Card is blocked or disabled', lastFour: '0113', phoneNumber: '628110113' },
      { scenario: 'Duplicate idempotency key', lastFour: '0111', phoneNumber: '628110111' }
    ];
    this.validatePayment = [
      { scenario: 'Validate payment invalid passcode', lastFour: '8190', phoneNumber: '628118190' },
      { scenario: 'Error Validate OTP Passcode', lastFour: '9190', phoneNumber: '628118190' },
      { scenario: 'Expired OTP', lastFour: '0290', phoneNumber: '628110290' },
      { scenario: 'Send OTP Failed', lastFour: '1290', phoneNumber: '628111290' },
      { scenario: 'Invalid OTP Token', lastFour: '2290', phoneNumber: '628112290' }
    ];
    this.refundOnline = [
      { scenario: 'Refund currency not supported', invoiceNumber: 'INV-0501' },
      { scenario: 'Refund amount is greater than paid amount', invoiceNumber: 'INV-0502' },
      { scenario: 'Refund payment failed', invoiceNumber: 'INV-0503' },
      { scenario: 'Account is frozen', invoiceNumber: 'INV-0405' },
      { scenario: 'Account is closed', invoiceNumber: 'INV-0406' }
    ];
  }

  home() {
    this.apiService.home();
  }

}
